<template>
  <div v-if="show" class="reason-container bg-light-gray rounded p-3">
    <div class="row">
      <div class="col-12">
        <span class="title d-flex align-items-center">
          <div class="circle-icon d-flex mr-2">
            <span class="fa-stack fa-1x">
              <i class="fas fa-circle fa-stack-2x text-white" />
              <i class="fas fa-undo-alt fa-stack-1x text-orange" />
            </span>
          </div>
          <span v-text="currentStatus.name" />
        </span>
      </div>

      <div class="col-12">
        <div class="p-3">
          <div class="row">
            <div class="col-12">
              <CustomTextArea
                label="Razón:"
                disabled
                regular-label
                :maxlength="3000"
                :value="currentStatus.reason"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import { mapGetters, mapState } from 'vuex';
import { statusManagementStore } from '@/components/pei/ubication-tech-assistance/_store';

export default {
  name: 'ChangeOfStatusReadonly',
  components: { CustomTextArea },
  computed: {
    ...mapState(statusManagementStore, ['currentStatus']),
    ...mapGetters(statusManagementStore, ['currentTabState']),
    show() {
      return (
        (this.currentTabState?.showStatusCard &&
          this.currentTabState?.statusCardReadonly) ||
        false
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.reason-container {
  border-left: 6px solid #e2e2e2;
  .circle-icon {
    box-shadow: 0px 3px 6px #00000029;
    width: 35px;
    border-radius: 35px;
  }
  .title {
    font: normal normal bold 16px/19px Lato;
    color: #3f5b60;
  }
}
textarea {
  min-height: 50px !important;
}
</style>
